import { SponsoredEvent } from './sponsored-event';

export interface SponsoredEvents {
  events: SponsoredEvent[];
  yearToDateSpend: {
    value: number;
    currencyCode: string;
  };
}
